
      (function () {
        var bfPage = document.querySelector('.bf2026-page');
        var bfAssetRoot = bfPage ? bfPage.getAttribute('data-bf-asset-root') : '';
        var products = [
          { n: "01", name: "UR1000", series: "ur", seriesLabel: "UR Series", img: bfAssetRoot + "bf2026-d639fd0bc4276188.webp", gimg: bfAssetRoot + "bf2026-2255bab60eb4859f.webp", alt: "iCARZONE UR1000 diagnostic tablet",
            desc: "Advanced diagnostics, coding, and modern protocol coverage.", price: "$329.99", was: "$349.99", save: "Save $20",
            url: "https://www.icarzone.com/products/icarzone-ur1000", checkoutUrl: "https://www.icarzone.com/cart/42528602947672:1?checkout" },
          { n: "02", name: "JU2000", series: "ju", seriesLabel: "JU Series", img: bfAssetRoot + "bf2026-b964eb5625624f48.webp", gimg: bfAssetRoot + "bf2026-5de671ea067e3904.webp", alt: "iCARZONE JU2000 diagnostic tablet",
            desc: "10-inch diagnostics, coding, TPMS programming, and full bidirectional control.", price: "$589.99", was: "$799.99", save: "Save $210",
            url: "https://www.icarzone.com/products/icarzone-ju2000", checkoutUrl: "https://www.icarzone.com/cart/44187479212120:1?checkout" },
          { n: "03", name: "MA200 Plus", series: "ma", seriesLabel: "MA Series", img: bfAssetRoot + "bf2026-92e2e3b2b9545075.webp", gimg: bfAssetRoot + "bf2026-2bbab212b0d11ed8.webp", alt: "iCARZONE MA200 Plus diagnostic tool",
            desc: "Compact all-system diagnostics, active tests, and six service functions.", price: "$144.99", was: "$179.99", save: "Save $35",
            url: "https://www.icarzone.com/products/icarzone-ma200-plus", checkoutUrl: "https://www.icarzone.com/cart/42836118306904:1?checkout" },
          { n: "04", name: "JU2000 MAX", series: "ju", seriesLabel: "JU Series", img: bfAssetRoot + "bf2026-a7cc3693fe7a346e.webp", gimg: bfAssetRoot + "bf2026-bcbc4bfa3735bfc2.webp", alt: "iCARZONE JU2000 MAX diagnostic tablet",
            desc: "Diagnostics, TPMS, J2534 pass-through support, and shop accessories.", price: "$1,186.99", was: "$1,249.00", save: "Save $62.01",
            url: "https://www.icarzone.com/products/ju2000-max", checkoutUrl: "https://www.icarzone.com/cart/44054421504088:1?checkout" },
          { n: "05", name: "UR800", series: "ur", seriesLabel: "UR Series", img: bfAssetRoot + "bf2026-029ee7a9d0d50c5b.webp", gimg: bfAssetRoot + "bf2026-5263cf99f2f323b2.webp", alt: "iCARZONE UR800 diagnostic tablet",
            desc: "Advanced service capability for growing diagnostic needs.", price: "$239.99", was: "$299.99", save: "Save $60",
            url: "https://www.icarzone.com/products/icarzone-ur800", checkoutUrl: "https://www.icarzone.com/cart/42537139241048:1?checkout" },
          { n: "06", name: "UR600", series: "ur", seriesLabel: "UR Series", img: bfAssetRoot + "bf2026-2fb0166cd70ca8f7.webp", gimg: bfAssetRoot + "bf2026-e56fbfc479196429.webp", alt: "iCARZONE UR600 diagnostic tablet",
            desc: "A practical route to deeper service and diagnostic work.", price: "$199.99", was: "$209.99", save: "Save $10",
            url: "https://www.icarzone.com/products/icarzone-ur600", checkoutUrl: "https://www.icarzone.com/cart/42528602914904:1?checkout" },
          { n: "07", name: "UR400", series: "ur", seriesLabel: "UR Series", img: bfAssetRoot + "bf2026-003c71b655ae999b.webp", gimg: bfAssetRoot + "bf2026-eefbbcea71514e7f.webp", alt: "iCARZONE UR400 diagnostic tablet",
            desc: "Confident core diagnostics for the independent garage.", price: "$189.99", was: "$199.99", save: "Save $10",
            url: "https://www.icarzone.com/products/icarzone-ur400", checkoutUrl: "https://www.icarzone.com/cart/42755712057432:1?checkout" },
          { n: "08", name: "UR300", series: "ur", seriesLabel: "UR Series", img: bfAssetRoot + "bf2026-e5dbae5f9f8308c9.webp", gimg: bfAssetRoot + "bf2026-455fb96a61c22439.webp", alt: "iCARZONE UR300 diagnostic tablet",
            desc: "More capability for regular maintenance and service work.", price: "$269.99", was: "$289.99", save: "Save $20",
            url: "https://www.icarzone.com/products/icarzone-ur300", checkoutUrl: "https://www.icarzone.com/cart/42820614651992:1?checkout" },
          { n: "09", name: "MA900", series: "ma", seriesLabel: "MA Series", img: bfAssetRoot + "bf2026-bb3cab2b5bd036bd.webp", gimg: bfAssetRoot + "bf2026-e2350a104ec10442.webp", alt: "iCARZONE MA900 code reader and battery tester",
            desc: "OBD2 code reading with 12V and 24V battery testing.", price: "$69.99", was: "$99.99", save: "Save $30",
            url: "https://www.icarzone.com/products/ma900", checkoutUrl: "https://www.icarzone.com/cart/43197829054552:1?checkout" },
          { n: "10", name: "MA500", series: "ma", seriesLabel: "MA Series", img: bfAssetRoot + "bf2026-9779041fdc48e80d.webp", gimg: bfAssetRoot + "bf2026-a2cb17dbd46a171f.webp", alt: "iCARZONE MA500 battery tester",
            desc: "Battery health, cranking, and charging system testing.", price: "$32.99", was: "", save: "Sale",
            url: "https://www.icarzone.com/products/icarzone-ma500", checkoutUrl: "https://www.icarzone.com/cart/43851945836632:1?checkout" },
          { n: "11", name: "MA200 V6", series: "ma", seriesLabel: "MA Series", img: bfAssetRoot + "bf2026-5123ed337b134881.webp", gimg: bfAssetRoot + "bf2026-00d10c44e1e65907.webp", alt: "iCARZONE MA200 V6 diagnostic tool",
            desc: "A simple path to smarter home-garage maintenance.", price: "$99.99", was: "$119.99", save: "Save $20",
            url: "https://www.icarzone.com/products/icarzone-ma200-v6", checkoutUrl: "https://www.icarzone.com/cart/42878917115992:1?checkout" },
          { n: "12", name: "MA100", series: "ma", seriesLabel: "MA Series", img: bfAssetRoot + "bf2026-090447d87c5d8f71.webp", gimg: bfAssetRoot + "bf2026-4fec482a3ff30408.webp", alt: "iCARZONE MA100 code reader",
            desc: "Essential code reading for quick checks and peace of mind.", price: "$22.99", was: "$39.99", save: "Save $17",
            url: "https://www.icarzone.com/products/icarzone-ma100", checkoutUrl: "https://www.icarzone.com/cart/42755582263384:1?checkout" },
          { n: "13", name: "HD S700", series: "hd", seriesLabel: "Heavy Duty", img: bfAssetRoot + "bf2026-ca6912e69887fb4a.webp", gimg: bfAssetRoot + "bf2026-c8064c79745d0b64.webp", alt: "iCARZONE HD S700 heavy-duty diagnostic tablet",
            desc: "Purpose-built diagnostics for commercial vehicle work.", price: "$392.99", was: "$429.99", save: "Save $37",
            url: "https://www.icarzone.com/products/icarzone-hd-s700", checkoutUrl: "https://www.icarzone.com/cart/43014779273304:1?checkout" }
        ];

        var grid = document.getElementById("grid");
        products.forEach(function (p, idx) {
          var card = document.createElement("article");
          card.className = "card";
          card.setAttribute("data-series", p.series);
          var wasHtml = p.was ? '<span class="card-was">' + p.was + "</span>" : "";
          var gimg = p.gimg;
          var bestHtml = idx < 4 ? '<span class="best-tag">Best Seller</span>' : '';
          card.innerHTML =
            '<div class="card-media">' + bestHtml + '<a href="' + p.url + '"><img src="' + gimg + '" alt="' + p.alt + '" loading="lazy" decoding="async" /></a></div>' +
            '<div class="card-body">' +
            '<span class="card-idx">No. ' + p.n + "  -  " + p.seriesLabel + "</span>" +
            '<h3 class="card-name"><a href="' + p.url + '">' + p.name + "</a></h3>" +
            '<p class="card-desc">' + p.desc + "</p>" +
            '<div class="card-foot"><span><span class="card-price">' + p.price + "</span>" + wasHtml +
            '<span class="card-save">' + p.save + "</span></span>" +
            '<a class="card-shop" href="' + p.checkoutUrl + '" aria-label="Buy ' + p.name + ' now and proceed to checkout"><span>Buy now</span><span class="buy-arrow" aria-hidden="true">&#8594;</span></a></div></div>';
          grid.appendChild(card);
        });

      })();
    


      (function () {
        var panels = Array.prototype.slice.call(document.querySelectorAll(".hl-panel"));
        var tabs = Array.prototype.slice.call(document.querySelectorAll(".hl-tab"));
        var dots = Array.prototype.slice.call(document.querySelectorAll(".hl-dot"));
        var counter = document.getElementById("hlCounter");
        var prev = document.getElementById("hlPrev");
        var next = document.getElementById("hlNext");
        if (!panels.length || !tabs.length) return;
        var current = 1;

        function show(idx) {
          current = ((idx % panels.length) + panels.length) % panels.length;
          panels.forEach(function (p, i) {
            var isActive = i === current;
            p.hidden = !isActive;
            p.classList.remove("hl-enter");
            if (isActive) { void p.offsetWidth; p.classList.add("hl-enter"); }
          });
          tabs.forEach(function (t, i) {
            var isActive = i === current;
            t.classList.toggle("active", isActive);
            t.setAttribute("aria-selected", isActive ? "true" : "false");
            t.tabIndex = isActive ? 0 : -1;
          });
          dots.forEach(function (d, i) { d.classList.toggle("active", i === current); });
          if (counter) counter.textContent = (current + 1) + " / " + panels.length;
        }

        tabs.forEach(function (t) {
          t.addEventListener("click", function () { show(parseInt(t.getAttribute("data-hl-index"), 10)); });
        });
        dots.forEach(function (d) {
          d.addEventListener("click", function () { show(parseInt(d.getAttribute("data-hl-dot"), 10)); });
        });
        if (prev) prev.addEventListener("click", function () { show(current - 1); });
        if (next) next.addEventListener("click", function () { show(current + 1); });

        var tablist = document.querySelector(".hl-tabs");
        if (tablist) {
          tablist.addEventListener("keydown", function (e) {
            var target = null;
            if (e.key === "ArrowRight") target = current + 1;
            else if (e.key === "ArrowLeft") target = current - 1;
            else if (e.key === "Home") target = 0;
            else if (e.key === "End") target = panels.length - 1;
            if (target !== null) {
              e.preventDefault();
              show(target);
              tabs[current].focus();
            }
          });
        }

        show(1);
      })();
    


      (function () {
        var DATA = [
          { name: "JU2000", desc: "Flagship Tablet", url: "https://www.icarzone.com/products/icarzone-ju2000" },
          { name: "UR1000", desc: "Diagnostic Scanner", url: "https://www.icarzone.com/products/icarzone-ur1000" },
          { name: "MA200 Plus", desc: "Compact Scanner", url: "https://www.icarzone.com/products/icarzone-ma200-plus" }
        ];
        var items = Array.prototype.slice.call(document.querySelectorAll(".c-item"));
        var plate = document.getElementById("carPlate");
        var nameEl = document.getElementById("carName");
        var descEl = document.getElementById("carDesc");
        var spin = document.getElementById("ringSpin");
        var prev = document.getElementById("carPrev");
        var next = document.getElementById("carNext");
        var ring = document.getElementById("heroCarousel");
        if (!items.length || !nameEl) return;
        var front = 0;
        var spinDeg = 0;

        function render(animatePlate) {
          items.forEach(function (it, i) {
            var off = ((i - front) % 3 + 3) % 3;
            it.classList.remove("slot-front", "slot-left", "slot-right");
            it.classList.add(off === 0 ? "slot-front" : off === 1 ? "slot-left" : "slot-right");
            if (off === 0) {
              it.setAttribute("aria-label", DATA[i].name + "  -  at the front. Activate to open its product page.");
              it.title = "View the " + DATA[i].name + " product page";
            } else {
              it.setAttribute("aria-label", "Bring " + DATA[i].name + " to the front");
              it.title = "Bring " + DATA[i].name + " to the front";
            }
          });
          nameEl.textContent = DATA[front].name;
          descEl.textContent = DATA[front].desc;
          if (plate) {
            plate.setAttribute("href", DATA[front].url);
            plate.setAttribute("aria-label", "Shop the " + DATA[front].name + "  -  " + DATA[front].desc);
          }
          if (spin) spin.style.transform = "rotate(" + spinDeg + "deg)";
          if (animatePlate && plate) {
            plate.classList.remove("swap");
            void plate.offsetWidth;
            plate.classList.add("swap");
          }
        }

        function rotateTo(idx) {
          var target = ((idx % 3) + 3) % 3;
          if (target === front) return;
          var delta = (((target - front + 1) % 3) + 3) % 3 - 1; /* shortest step: -1 or +1 */
          spinDeg += delta * 120;
          front = target;
          render(true);
        }

        items.forEach(function (it) {
          it.addEventListener("click", function () {
            var idx = parseInt(it.getAttribute("data-index"), 10);
            if (idx === front) {
              window.location.href = it.getAttribute("data-url");
            } else {
              rotateTo(idx);
            }
          });
        });
        if (prev) prev.addEventListener("click", function () { rotateTo(front - 1); });
        if (next) next.addEventListener("click", function () { rotateTo(front + 1); });
        if (ring) {
          ring.addEventListener("keydown", function (e) {
            if (e.key === "ArrowRight") { e.preventDefault(); rotateTo(front + 1); }
            else if (e.key === "ArrowLeft") { e.preventDefault(); rotateTo(front - 1); }
          });
        }

        render(false);
      })();
    


      (function () {
        var target = new Date("2026-11-27T00:00:00-05:00").getTime();
        var boxes = document.getElementById("bfCdBoxes");
        var live = document.getElementById("bfCdLive");
        var dEl = document.getElementById("bfCdD");
        var hEl = document.getElementById("bfCdH");
        var mEl = document.getElementById("bfCdM");
        var sEl = document.getElementById("bfCdS");
        if (!boxes || !dEl || !hEl || !mEl || !sEl) return;
        function pad(n) { return (n < 10 ? "0" : "") + n; }
        var timer = null;
        function tick() {
          var diff = target - Date.now();
          if (diff <= 0) {
            boxes.hidden = true;
            if (live) live.hidden = false;
            if (timer) { clearInterval(timer); timer = null; }
            return;
          }
          var s = Math.floor(diff / 1000);
          dEl.textContent = pad(Math.floor(s / 86400));
          hEl.textContent = pad(Math.floor((s % 86400) / 3600));
          mEl.textContent = pad(Math.floor((s % 3600) / 60));
          sEl.textContent = pad(s % 60);
        }
        tick();
        timer = setInterval(tick, 1000);
      })();
    


(function () {
  if ('IntersectionObserver' in window) {
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        entry.target.classList.toggle('motion-offscreen', !entry.isIntersecting);
      });
    }, { rootMargin: window.matchMedia('(max-width: 600px)').matches ? '300px 0px 300px 0px' : '500px 0px 500px 0px', threshold: 0 });
    document.querySelectorAll('.hero-shell, .hero-theme, .hero-group, .hero-lights, main > section.block, main > .fest-divider, main > .closing, .blog-poster, .fest-garland').forEach(function (el) { observer.observe(el); });
  }
  function updateVisibility() { document.documentElement.classList.toggle('page-inactive', document.hidden); }
  document.addEventListener('visibilitychange', updateVisibility);
  updateVisibility();
})();
